import { ActionEnum } from '../commons/commons.types';
import { SensorFamilyEnum } from '../sensor/sensor.types';

export enum RoleEnum {
  // CONFIGURATION
  ACCESS_COLLABORATIVE_SENSOR = 'ACCESS_COLLABORATIVE_SENSOR',
  CREATE_COLLABORATIVE_SENSOR = 'CREATE_COLLABORATIVE_SENSOR',
  COMMAND_COLLABORATIVE_SENSOR = 'COMMAND_COLLABORATIVE_SENSOR',
  DELETE_COLLABORATIVE_SENSOR = 'DELETE_COLLABORATIVE_SENSOR',
  EDIT_COLLABORATIVE_SENSOR = 'EDIT_COLLABORATIVE_SENSOR',
  MAINTAIN_COLLABORATIVE_SENSOR = 'MAINTAIN_COLLABORATIVE_SENSOR',

  ACCESS_NEUTRAL_SENSOR = 'ACCESS_NEUTRAL_SENSOR',
  CREATE_NEUTRAL_SENSOR = 'CREATE_NEUTRAL_SENSOR',
  COMMAND_NEUTRAL_SENSOR = 'COMMAND_NEUTRAL_SENSOR',
  DELETE_NEUTRAL_SENSOR = 'DELETE_NEUTRAL_SENSOR',
  EDIT_NEUTRAL_SENSOR = 'EDIT_NEUTRAL_SENSOR',
  MAINTAIN_NEUTRAL_SENSOR = 'MAINTAIN_NEUTRAL_SENSOR',

  ACCESS_RF_SENSOR = 'ACCESS_RF_SENSOR',
  CREATE_RF_SENSOR = 'CREATE_RF_SENSOR',
  COMMAND_RF_SENSOR = 'COMMAND_RF_SENSOR',
  DELETE_RF_SENSOR = 'DELETE_RF_SENSOR',
  EDIT_RF_SENSOR = 'EDIT_RF_SENSOR',
  MAINTAIN_RF_SENSOR = 'MAINTAIN_RF_SENSOR',

  ACCESS_CAMERA_SENSOR = 'ACCESS_CAMERA_SENSOR',
  CREATE_CAMERA_SENSOR = 'CREATE_CAMERA_SENSOR',
  COMMAND_CAMERA_SENSOR = 'COMMAND_CAMERA_SENSOR',
  DELETE_CAMERA_SENSOR = 'DELETE_CAMERA_SENSOR',
  EDIT_CAMERA_SENSOR = 'EDIT_CAMERA_SENSOR',
  MAINTAIN_CAMERA_SENSOR = 'MAINTAIN_CAMERA_SENSOR',
  TAKE_STANDARD_CONTROL_CAMERA_SENSOR = 'TAKE_STANDARD_CONTROL_CAMERA_SENSOR',
  TAKE_PREMIUM_CONTROL_CAMERA_SENSOR = 'TAKE_PREMIUM_CONTROL_CAMERA_SENSOR',
  DEICING_CAMERA_SENSOR = 'DEICING_CAMERA_SENSOR',

  ACCESS_RADAR_SENSOR = 'ACCESS_RADAR_SENSOR',
  CREATE_RADAR_SENSOR = 'CREATE_RADAR_SENSOR',
  COMMAND_RADAR_SENSOR = 'COMMAND_RADAR_SENSOR',
  DELETE_RADAR_SENSOR = 'DELETE_RADAR_SENSOR',
  EDIT_RADAR_SENSOR = 'EDIT_RADAR_SENSOR',
  MAINTAIN_RADAR_SENSOR = 'MAINTAIN_RADAR_SENSOR',

  ACCESS_AUTOMATON_SENSOR = 'ACCESS_AUTOMATON_SENSOR',
  CREATE_AUTOMATON_SENSOR = 'CREATE_AUTOMATON_SENSOR',
  COMMAND_AUTOMATON_SENSOR = 'COMMAND_AUTOMATON_SENSOR',
  DELETE_AUTOMATON_SENSOR = 'DELETE_AUTOMATON_SENSOR',
  EDIT_AUTOMATON_SENSOR = 'EDIT_AUTOMATON_SENSOR',
  MAINTAIN_AUTOMATON_SENSOR = 'MAINTAIN_AUTOMATON_SENSOR',
  ACTIVATE_REPULSION_AUTOMATON = 'ACTIVATE_REPULSION_AUTOMATON',
  DEACTIVATE_REPULSION_AUTOMATON = 'DEACTIVATE_REPULSION_AUTOMATON',

  ACCESS_PERIMETER_CAMERA = 'ACCESS_PERIMETER_CAMERA',
  CREATE_PERIMETER_CAMERA = 'CREATE_PERIMETER_CAMERA',
  EDIT_PERIMETER_CAMERA = 'EDIT_PERIMETER_CAMERA',
  DELETE_PERIMETER_CAMERA = 'DELETE_PERIMETER_CAMERA',

  ACCESS_EQUIPMENT = 'ACCESS_EQUIPMENT',
  CREATE_EQUIPMENT = 'CREATE_EQUIPMENT',
  EDIT_EQUIPMENT = 'EDIT_EQUIPMENT',
  MAINTAIN_EQUIPMENT = 'MAINTAIN_EQUIPMENT',
  DELETE_EQUIPMENT = 'DELETE_EQUIPMENT',

  ACCESS_SITE = 'ACCESS_SITE',
  EDIT_SITE = 'EDIT_SITE',
  DELETE_SITE = 'DELETE_SITE',

  ACCESS_HOME = 'ACCESS_HOME',
  EDIT_HOME = 'EDIT_HOME',
  DELETE_HOME = 'DELETE_HOME',

  CREATE_MAP_LAYER = 'CREATE_MAP_LAYER',
  ACCESS_MAP_LAYER = 'ACCESS_MAP_LAYER',
  EDIT_MAP_LAYER = 'EDIT_MAP_LAYER',
  DELETE_MAP_LAYER = 'DELETE_MAP_LAYER',

  ACCESS_CONTACT = 'ACCESS_CONTACT',
  CREATE_CONTACT = 'CREATE_CONTACT',
  EDIT_CONTACT = 'EDIT_CONTACT',
  DELETE_CONTACT = 'DELETE_CONTACT',

  ACCESS_MSG = 'ACCESS_MSG',
  CREATE_MSG = 'CREATE_MSG',

  ACCESS_MESSAGE_REQUEST = 'ACCESS_MESSAGE_REQUEST',

  ACCESS_INSTRUCTION = 'ACCESS_INSTRUCTION',
  CREATE_INSTRUCTION = 'CREATE_INSTRUCTION',

  ACCESS_ZONE_NFZ = 'ACCESS_ZONE_NFZ',
  CREATE_ZONE_NFZ = 'CREATE_ZONE_NFZ',
  EDIT_ZONE_NFZ = 'EDIT_ZONE_NFZ',
  DELETE_ZONE_NFZ = 'DELETE_ZONE_NFZ',

  ACCESS_ZONE_IMZ = 'ACCESS_ZONE_IMZ',
  CREATE_ZONE_IMZ = 'CREATE_ZONE_IMZ',
  EDIT_ZONE_IMZ = 'EDIT_ZONE_IMZ',
  DELETE_ZONE_IMZ = 'DELETE_ZONE_IMZ',

  ACCESS_ZONE_NIZ = 'ACCESS_ZONE_NIZ',
  CREATE_ZONE_NIZ = 'CREATE_ZONE_NIZ',
  EDIT_ZONE_NIZ = 'EDIT_ZONE_NIZ',
  DELETE_ZONE_NIZ = 'DELETE_ZONE_NIZ',

  ACCESS_ZONE_NNZ = 'ACCESS_ZONE_NNZ',
  CREATE_ZONE_NNZ = 'CREATE_ZONE_NNZ',
  EDIT_ZONE_NNZ = 'EDIT_ZONE_NNZ',
  DELETE_ZONE_NNZ = 'DELETE_ZONE_NNZ',

  ACCESS_POI = 'ACCESS_POI',
  CREATE_POI = 'CREATE_POI',
  EDIT_POI = 'EDIT_POI',
  DELETE_POI = 'DELETE_POI',

  ACCESS_ZONE_ZOI = 'ACCESS_ZONE_ZOI',
  CREATE_ZONE_ZOI = 'CREATE_ZONE_ZOI',
  EDIT_ZONE_ZOI = 'EDIT_ZONE_ZOI',
  DELETE_ZONE_ZOI = 'DELETE_ZONE_ZOI',

  ACCESS_ROUND_CONFIGURATION = 'ACCESS_ROUND_CONFIGURATION',
  CREATE_ROUND_CONFIGURATION = 'CREATE_ROUND_CONFIGURATION',
  EDIT_ROUND_CONFIGURATION = 'EDIT_ROUND_CONFIGURATION',
  DELETE_ROUND_CONFIGURATION = 'DELETE_ROUND_CONFIGURATION',

  ACCESS_VIDEO_STREAM = 'ACCESS_VIDEO_STREAM',
  CREATE_VIDEO_STREAM = 'CREATE_VIDEO_STREAM',
  EDIT_VIDEO_STREAM = 'EDIT_VIDEO_STREAM',
  DELETE_VIDEO_STREAM = 'DELETE_VIDEO_STREAM',

  IMPORT = 'IMPORT',
  EXPORT = 'EXPORT',

  ACCESS_MERGING = 'ACCESS_MERGING',

  ACCESS_STORAGE = 'ACCESS_STORAGE',
  CREATE_STORAGE = 'CREATE_STORAGE',
  EDIT_STORAGE = 'EDIT_STORAGE',

  ACCESS_GLOBAL_SCREEN_CONFIGURATION = 'ACCESS_GLOBAL_SCREEN_CONFIGURATION',
  CREATE_GLOBAL_SCREEN_CONFIGURATION = 'CREATE_GLOBAL_SCREEN_CONFIGURATION',
  EDIT_GLOBAL_SCREEN_CONFIGURATION = 'EDIT_GLOBAL_SCREEN_CONFIGURATION',
  DELETE_GLOBAL_SCREEN_CONFIGURATION = 'DELETE_GLOBAL_SCREEN_CONFIGURATION',

  EDIT_MAP_FILTERS = 'EDIT_MAP_FILTERS',

  ACCESS_PLATFORM = 'ACCESS_PLATFORM',
  CREATE_PLATFORM = 'CREATE_PLATFORM',
  EDIT_PLATFORM = 'EDIT_PLATFORM',
  DELETE_PLATFORM = 'DELETE_PLATFORM',

  ACCESS_ORGANIZATION = 'ACCESS_ORGANIZATION',
  CREATE_ORGANIZATION = 'CREATE_ORGANIZATION',
  EDIT_ORGANIZATION = 'EDIT_ORGANIZATION',
  DELETE_ORGANIZATION = 'DELETE_ORGANIZATION',

  ACCESS_PROCEDURE_MODEL = 'ACCESS_PROCEDURE_MODEL',
  CREATE_PROCEDURE_MODEL = 'CREATE_PROCEDURE_MODEL',
  EDIT_PROCEDURE_MODEL = 'EDIT_PROCEDURE_MODEL',
  DELETE_PROCEDURE_MODEL = 'DELETE_PROCEDURE_MODEL',

  // LIVE
  ACCESS_SITUATION = 'ACCESS_SITUATION',
  ACCESS_PLOT = 'ACCESS_PLOT',
  MANAGE_SITUATION = 'MANAGE_SITUATION',

  ACCESS_SYSTEM_LOG = 'ACCESS_SYSTEM_LOG',

  MANAGE_FLY_ROUTE = 'MANAGE_FLY_ROUTE',

  COMMAND_EQUIPMENT = 'COMMAND_EQUIPMENT',

  ACCESS_TARGET_COLLABORATIVE = 'ACCESS_TARGET_COLLABORATIVE',
  ACCESS_TARGET_CAMERA = 'ACCESS_TARGET_CAMERA',
  ACCESS_TARGET_RADAR = 'ACCESS_TARGET_RADAR',
  ACCESS_TARGET_RF = 'ACCESS_TARGET_RF',
  ACCESS_TARGET_AUTOMATON_EFFRACTION_ALERT = 'ACCESS_TARGET_AUTOMATON_EFFRACTION_ALERT', // Here because it's of ACCESS_TARGET action family

  MANAGE_TARGET_COLLABORATIVE = 'MANAGE_TARGET_COLLABORATIVE',
  MANAGE_TARGET_RADAR = 'MANAGE_TARGET_RADAR',
  MANAGE_TARGET_RF = 'MANAGE_TARGET_RF',
  MANAGE_TARGET_AUTOMATON_EFFRACTION_ALERT = 'MANAGE_TARGET_AUTOMATON_EFFRACTION_ALERT', // Here because it's of MANAGE_TARGET action family
  MANAGE_CLASSIFICATION = 'MANAGE_CLASSIFICATION',

  MARK_TRACKS = 'MARK_TRACKS',

  MANAGE_ROUND = 'MANAGE_ROUND',

  //DATA
  EXPORT_NOTIFICATIONS = 'EXPORT_NOTIFICATIONS',

  // PLANNING
  ACCESS_DRONE = 'ACCESS_DRONE',
  CREATE_DRONE = 'CREATE_DRONE',
  EDIT_DRONE = 'EDIT_DRONE',
  DELETE_DRONE = 'DELETE_DRONE',

  MANAGE_CLEARANCE = 'MANAGE_CLEARANCE',
  MANAGE_TACTICAL_CLEARANCE = 'MANAGE_TACTICAL_CLEARANCE',

  ACCESS_PILOT = 'ACCESS_PILOT',
  CREATE_PILOT = 'CREATE_PILOT',
  EDIT_PILOT = 'EDIT_PILOT',
  DELETE_PILOT = 'DELETE_PILOT',

  ACCESS_FLEET = 'ACCESS_FLEET',
  CREATE_FLEET = 'CREATE_FLEET',
  EDIT_FLEET = 'EDIT_FLEET',
  DELETE_FLEET = 'DELETE_FLEET',

  ACCESS_FLY_ZONE = 'ACCESS_FLY_ZONE',
  CREATE_FLY_ZONE = 'CREATE_FLY_ZONE',
  EDIT_FLY_ZONE = 'EDIT_FLY_ZONE',
  DELETE_FLY_ZONE = 'DELETE_FLY_ZONE',

  ACCESS_FLIGHT_PLAN = 'ACCESS_FLIGHT_PLAN',
  CREATE_FLIGHT_PLAN = 'CREATE_FLIGHT_PLAN',
  EDIT_FLIGHT_PLAN = 'EDIT_FLIGHT_PLAN',
  DELETE_FLIGHT_PLAN = 'DELETE_FLIGHT_PLAN',
  VALIDATE_FLIGHT_PLAN = 'VALIDATE_FLIGHT_PLAN',

  ACCESS_FATO = 'ACCESS_FATO',
  EDIT_FATO = 'EDIT_FATO',

  ACCESS_FLY_ROUTE = 'ACCESS_FLY_ROUTE',
  CREATE_FLY_ROUTE = 'CREATE_FLY_ROUTE',
  EDIT_FLY_ROUTE = 'EDIT_FLY_ROUTE',
  DELETE_FLY_ROUTE = 'DELETE_FLY_ROUTE',

  // REPLAY
  ACCESS_REPLAY = 'ACCESS_REPLAY',
  CREATE_REPLAY = 'CREATE_REPLAY',
  EDIT_REPLAY = 'EDIT_REPLAY',
  DELETE_REPLAY = 'DELETE_REPLAY',
  EXPORT_VIDEO = 'EXPORT_VIDEO',

  // USERS
  ACCESS_USER = 'ACCESS_USER',
  CREATE_USER = 'CREATE_USER',
  EDIT_USER = 'EDIT_USER',
  DELETE_USER = 'DELETE_USER',
  EDIT_AUTHENT_SETTINGS = 'EDIT_AUTHENT_SETTINGS',

  ACCESS_GROUP = 'ACCESS_GROUP',
  CREATE_GROUP = 'CREATE_GROUP',
  EDIT_GROUP = 'EDIT_GROUP',
  DELETE_GROUP = 'DELETE_GROUP',

  ACCESS_PROFILE = 'ACCESS_PROFILE',
  CREATE_PROFILE = 'CREATE_PROFILE',
  EDIT_PROFILE = 'EDIT_PROFILE',
  DELETE_PROFILE = 'DELETE_PROFILE',

  ACCESS_SAFETY_KEY = 'ACCESS_SAFETY_KEY',
  CREATE_SAFETY_KEY = 'CREATE_SAFETY_KEY',
  EDIT_SAFETY_KEY = 'EDIT_SAFETY_KEY',
  DELETE_SAFETY_KEY = 'DELETE_SAFETY_KEY',

  ACCESS_USER_ACTION = 'ACCESS_USER_ACTION',
  CREATE_USER_ACTION = 'CREATE_USER_ACTION',

  // TECHNICAL
  ADMIN = 'ADMIN', // technical role that bypasses every authorization

  /* Hidden technical roles
  HAS_ALL_ORGANIZATION = 'HAS_ALL_ORGANIZATION',
  APP = 'APP'
  */
}

export const minimumRolesEnum: RoleEnum[] = [RoleEnum.ACCESS_SITUATION, RoleEnum.ACCESS_HOME] as const;

export enum RoleOperationalDomainCategoryEnum {
  LAD = 'LAD',
  PERIMETER = 'PERIMETER',
  UTM = 'UTM',
  CONFIGURATION = 'CONFIGURATION',
  USERS = 'USERS',
}

export enum RoleTaskCategoryEnum {
  OPERATION = 'OPERATION',
  SUPERVISION = 'SUPERVISION',
  MAINTENANCE = 'MAINTENANCE',
  MANAGEMENT = 'MANAGEMENT',
  ADMINISTRATION = 'ADMINISTRATION',
  APPLICATION = 'APPLICATION',
  SUPER_ADMINISTRATION = 'SUPER_ADMINISTRATION', // technical TaskCategory for roles that bypass every authorization
}

export type Role = {
  roleName: RoleEnum;
  operationalDomainCategory: RoleOperationalDomainCategoryEnum;
  taskCategory: RoleTaskCategoryEnum;
  action: ActionEnum | null;
  sensorFamily: SensorFamilyEnum | null;
};

export const roleMap: Record<string, Record<string, RoleEnum[]>> = {
  sensors: {
    collaboratives: [
      RoleEnum.ACCESS_COLLABORATIVE_SENSOR,
      RoleEnum.CREATE_COLLABORATIVE_SENSOR,
      RoleEnum.EDIT_COLLABORATIVE_SENSOR,
      RoleEnum.DELETE_COLLABORATIVE_SENSOR,
      RoleEnum.COMMAND_COLLABORATIVE_SENSOR,
      RoleEnum.MAINTAIN_COLLABORATIVE_SENSOR,
    ],
    rf: [
      RoleEnum.ACCESS_RF_SENSOR,
      RoleEnum.CREATE_RF_SENSOR,
      RoleEnum.EDIT_RF_SENSOR,
      RoleEnum.DELETE_RF_SENSOR,
      RoleEnum.COMMAND_RF_SENSOR,
      RoleEnum.MAINTAIN_RF_SENSOR,
    ],
    radars: [
      RoleEnum.ACCESS_RADAR_SENSOR,
      RoleEnum.CREATE_RADAR_SENSOR,
      RoleEnum.EDIT_RADAR_SENSOR,
      RoleEnum.DELETE_RADAR_SENSOR,
      RoleEnum.COMMAND_RADAR_SENSOR,
      RoleEnum.MAINTAIN_RADAR_SENSOR,
    ],
    automatons: [
      RoleEnum.ACCESS_AUTOMATON_SENSOR,
      RoleEnum.CREATE_AUTOMATON_SENSOR,
      RoleEnum.EDIT_AUTOMATON_SENSOR,
      RoleEnum.DELETE_AUTOMATON_SENSOR,
      RoleEnum.COMMAND_AUTOMATON_SENSOR,
      RoleEnum.MAINTAIN_AUTOMATON_SENSOR,
      RoleEnum.ACTIVATE_REPULSION_AUTOMATON,
      RoleEnum.DEACTIVATE_REPULSION_AUTOMATON,
    ],
    equipments: [
      RoleEnum.ACCESS_EQUIPMENT,
      RoleEnum.CREATE_EQUIPMENT,
      RoleEnum.EDIT_EQUIPMENT,
      RoleEnum.DELETE_EQUIPMENT,
      RoleEnum.MAINTAIN_EQUIPMENT,
      RoleEnum.COMMAND_EQUIPMENT,
    ],
  },
  neutral: {
    neutral: [
      RoleEnum.ACCESS_NEUTRAL_SENSOR,
      RoleEnum.CREATE_NEUTRAL_SENSOR,
      RoleEnum.EDIT_NEUTRAL_SENSOR,
      RoleEnum.DELETE_NEUTRAL_SENSOR,
      RoleEnum.COMMAND_NEUTRAL_SENSOR,
      RoleEnum.MAINTAIN_NEUTRAL_SENSOR,
    ],
    safetyKey: [
      RoleEnum.ACCESS_SAFETY_KEY,
      RoleEnum.CREATE_SAFETY_KEY,
      RoleEnum.EDIT_SAFETY_KEY,
      RoleEnum.DELETE_SAFETY_KEY,
    ],
  },
  cameras: {
    lad: [
      RoleEnum.ACCESS_CAMERA_SENSOR,
      RoleEnum.CREATE_CAMERA_SENSOR,
      RoleEnum.EDIT_CAMERA_SENSOR,
      RoleEnum.DELETE_CAMERA_SENSOR,
      RoleEnum.COMMAND_CAMERA_SENSOR,
      RoleEnum.MAINTAIN_CAMERA_SENSOR,
      RoleEnum.TAKE_STANDARD_CONTROL_CAMERA_SENSOR,
      RoleEnum.TAKE_PREMIUM_CONTROL_CAMERA_SENSOR,
      RoleEnum.MANAGE_ROUND,
      RoleEnum.DEICING_CAMERA_SENSOR,
    ],
    perimeters: [
      RoleEnum.ACCESS_PERIMETER_CAMERA,
      RoleEnum.CREATE_PERIMETER_CAMERA,
      RoleEnum.EDIT_PERIMETER_CAMERA,
      RoleEnum.DELETE_PERIMETER_CAMERA,
    ],
    videoStreams: [
      RoleEnum.ACCESS_VIDEO_STREAM,
      RoleEnum.CREATE_VIDEO_STREAM,
      RoleEnum.EDIT_VIDEO_STREAM,
      RoleEnum.DELETE_VIDEO_STREAM,
    ],
    rounds: [
      RoleEnum.ACCESS_ROUND_CONFIGURATION,
      RoleEnum.CREATE_ROUND_CONFIGURATION,
      RoleEnum.EDIT_ROUND_CONFIGURATION,
      RoleEnum.DELETE_ROUND_CONFIGURATION,
    ],
  },
  communication: {
    chat: [RoleEnum.ACCESS_MSG, RoleEnum.CREATE_MSG],
    alertMessages: [RoleEnum.ACCESS_MESSAGE_REQUEST],
    instructions: [RoleEnum.ACCESS_INSTRUCTION, RoleEnum.CREATE_INSTRUCTION],
    events: [RoleEnum.ACCESS_REPLAY, RoleEnum.CREATE_REPLAY, RoleEnum.EDIT_REPLAY, RoleEnum.DELETE_REPLAY],
    systemLogs: [RoleEnum.ACCESS_SYSTEM_LOG],
    contacts: [RoleEnum.ACCESS_CONTACT, RoleEnum.CREATE_CONTACT, RoleEnum.EDIT_CONTACT, RoleEnum.DELETE_CONTACT],
    videos: [RoleEnum.EXPORT_VIDEO],
    notifications: [RoleEnum.EXPORT_NOTIFICATIONS],
    marks: [RoleEnum.MARK_TRACKS],
  },
  userManagement: {
    users: [RoleEnum.ACCESS_USER, RoleEnum.CREATE_USER, RoleEnum.EDIT_USER, RoleEnum.DELETE_USER],
    groups: [RoleEnum.ACCESS_GROUP, RoleEnum.CREATE_GROUP, RoleEnum.EDIT_GROUP, RoleEnum.DELETE_GROUP],
    profiles: [RoleEnum.ACCESS_PROFILE, RoleEnum.CREATE_PROFILE, RoleEnum.EDIT_PROFILE, RoleEnum.DELETE_PROFILE],
    actions: [RoleEnum.ACCESS_USER_ACTION, RoleEnum.CREATE_USER_ACTION],
  },
  trafficManagement: {
    drones: [RoleEnum.ACCESS_DRONE, RoleEnum.CREATE_DRONE, RoleEnum.EDIT_DRONE, RoleEnum.DELETE_DRONE],
    pilots: [RoleEnum.ACCESS_PILOT, RoleEnum.CREATE_PILOT, RoleEnum.EDIT_PILOT, RoleEnum.DELETE_PILOT],
    fleets: [RoleEnum.ACCESS_FLEET, RoleEnum.CREATE_FLEET, RoleEnum.EDIT_FLEET, RoleEnum.DELETE_FLEET],
    flyRoutes: [
      RoleEnum.ACCESS_FLY_ROUTE,
      RoleEnum.CREATE_FLY_ROUTE,
      RoleEnum.EDIT_FLY_ROUTE,
      RoleEnum.DELETE_FLY_ROUTE,
      RoleEnum.MANAGE_FLY_ROUTE,
    ],
    flyZones: [RoleEnum.ACCESS_FLY_ZONE, RoleEnum.CREATE_FLY_ZONE, RoleEnum.EDIT_FLY_ZONE, RoleEnum.DELETE_FLY_ZONE],
    flightPlans: [
      RoleEnum.ACCESS_FLIGHT_PLAN,
      RoleEnum.CREATE_FLIGHT_PLAN,
      RoleEnum.EDIT_FLIGHT_PLAN,
      RoleEnum.DELETE_FLIGHT_PLAN,
      RoleEnum.VALIDATE_FLIGHT_PLAN,
    ],
    fato: [RoleEnum.ACCESS_FATO, RoleEnum.EDIT_FATO],
  },
  trafficMonitoring: {
    effractions: [RoleEnum.ACCESS_TARGET_AUTOMATON_EFFRACTION_ALERT, RoleEnum.MANAGE_TARGET_AUTOMATON_EFFRACTION_ALERT],
    clearance: [RoleEnum.MANAGE_CLEARANCE],
    tacticalClearance: [RoleEnum.MANAGE_TACTICAL_CLEARANCE],
    collaborativeTargets: [RoleEnum.ACCESS_TARGET_COLLABORATIVE, RoleEnum.MANAGE_TARGET_COLLABORATIVE],
    radarTargets: [RoleEnum.ACCESS_TARGET_RADAR, RoleEnum.MANAGE_TARGET_RADAR],
    rfTargets: [RoleEnum.ACCESS_TARGET_RF, RoleEnum.MANAGE_TARGET_RF],
    classification: [RoleEnum.MANAGE_CLASSIFICATION],
  },
  systemConfiguration: {
    situation: [RoleEnum.ACCESS_SITUATION],
    screenConfigurations: [
      RoleEnum.ACCESS_GLOBAL_SCREEN_CONFIGURATION,
      RoleEnum.CREATE_GLOBAL_SCREEN_CONFIGURATION,
      RoleEnum.EDIT_GLOBAL_SCREEN_CONFIGURATION,
      RoleEnum.DELETE_GLOBAL_SCREEN_CONFIGURATION,
    ],
    procedures: [
      RoleEnum.ACCESS_PROCEDURE_MODEL,
      RoleEnum.CREATE_PROCEDURE_MODEL,
      RoleEnum.EDIT_PROCEDURE_MODEL,
      RoleEnum.DELETE_PROCEDURE_MODEL,
    ],
    plots: [RoleEnum.ACCESS_PLOT],
    platforms: [RoleEnum.ACCESS_PLATFORM, RoleEnum.CREATE_PLATFORM, RoleEnum.EDIT_PLATFORM, RoleEnum.DELETE_PLATFORM],
    organization: [
      RoleEnum.ACCESS_ORGANIZATION,
      RoleEnum.CREATE_ORGANIZATION,
      RoleEnum.EDIT_ORGANIZATION,
      RoleEnum.DELETE_ORGANIZATION,
    ],
    sites: [RoleEnum.ACCESS_SITE, RoleEnum.EDIT_SITE, RoleEnum.DELETE_SITE],
    home: [RoleEnum.ACCESS_HOME, RoleEnum.EDIT_HOME, RoleEnum.DELETE_HOME],
    c2Configuration: [RoleEnum.IMPORT, RoleEnum.EXPORT],
    merging: [RoleEnum.ACCESS_MERGING],
    storage: [RoleEnum.ACCESS_STORAGE, RoleEnum.CREATE_STORAGE, RoleEnum.EDIT_STORAGE],
    authent: [RoleEnum.EDIT_AUTHENT_SETTINGS],
  },
  cartography: {
    mapBackgrounds: [
      RoleEnum.ACCESS_MAP_LAYER,
      RoleEnum.CREATE_MAP_LAYER,
      RoleEnum.EDIT_MAP_LAYER,
      RoleEnum.DELETE_MAP_LAYER,
    ],
    filter: [RoleEnum.EDIT_MAP_FILTERS],
  },
  zoneManagement: {
    nfz: [RoleEnum.ACCESS_ZONE_NFZ, RoleEnum.CREATE_ZONE_NFZ, RoleEnum.EDIT_ZONE_NFZ, RoleEnum.DELETE_ZONE_NFZ],
    imz: [RoleEnum.ACCESS_ZONE_IMZ, RoleEnum.CREATE_ZONE_IMZ, RoleEnum.EDIT_ZONE_IMZ, RoleEnum.DELETE_ZONE_IMZ],
    niz: [RoleEnum.ACCESS_ZONE_NIZ, RoleEnum.CREATE_ZONE_NIZ, RoleEnum.EDIT_ZONE_NIZ, RoleEnum.DELETE_ZONE_NIZ],
    nnz: [RoleEnum.ACCESS_ZONE_NNZ, RoleEnum.CREATE_ZONE_NNZ, RoleEnum.EDIT_ZONE_NNZ, RoleEnum.DELETE_ZONE_NNZ],
    poi: [RoleEnum.ACCESS_POI, RoleEnum.CREATE_POI, RoleEnum.EDIT_POI, RoleEnum.DELETE_POI],
    zoi: [RoleEnum.ACCESS_ZONE_ZOI, RoleEnum.CREATE_ZONE_ZOI, RoleEnum.EDIT_ZONE_ZOI, RoleEnum.DELETE_ZONE_ZOI],
  },
} as const;

export enum RoleActionEnum {
  ACCESS = 'ACCESS',
  CREATE = 'CREATE',
  EDIT = 'EDIT',
  DELETE = 'DELETE',
  COMMAND = 'COMMAND',
  MAINTAIN = 'MAINTAIN',
  MANAGE = 'MANAGE',
  IMPORT = 'IMPORT',
  EXPORT = 'EXPORT',
  VALIDATE = 'VALIDATE',
}
